import React from 'react';

import { LEVEL_TRAVEL_OPERATOR_ID } from 'src/constants/flights';
import MealIcon from '@lt/components/icons-react/rebrand/Meal';
import PackageInfoItem from '../PackageInfoItem';

import type { IPackageMealInfo } from '../../types';
import styles from './packageMealInfo.module.css';

const PackageMealInfo = ({
  meal,
  mealCode,
  mealOriginal = null,
  operatorId,
  icon,
}: IPackageMealInfo): JSX.Element => {
  const isLTOperator = operatorId === LEVEL_TRAVEL_OPERATOR_ID;
  return (
    <PackageInfoItem icon={icon || <MealIcon height={16} />}>
      <>
        <p className={styles.text}>{meal}</p>
        <p className={styles.text}>{`(${mealCode})`}</p>
        {mealOriginal && meal !== mealOriginal && !isLTOperator && (
          <>
            <p className={styles.text}>·</p>
            <p className={styles.text}>{mealOriginal}</p>
          </>
        )}
      </>
    </PackageInfoItem>
  );
};

export default PackageMealInfo;
